<template>
  <Loader v-if="loader" />
  <Toast position="bottom-right" />
  <div class="table-container">
    <div class="filter-container">
      <button
        v-for="option in tipoPraticaOptions"
        :key="option.value"
        class="btn-filter p-button"
        :class="{ selected: selectedTipoPratica === option.value }"
        @click="selectedTipoPratica = option.value"
      >
        {{ option.label }}
      </button>
    </div>
    <DataTable
      :value="filteredPreventivi"
      :paginator="true"
      :rows="50"
      @row-click="onRowClick"
      selectionMode="single"
      :rowClass="rowClass"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[100, 150]"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
    >
      <Column field="clienteRagioneSociale" header="Cliente" sortable>
        <template #body="slotProps">
          <a
            href="#"
            @click.prevent="openClienteDetails(slotProps.data)"
            class="cliente-link"
          >
            {{
              slotProps.data.clienteRagioneSociale ||
              slotProps.data.nomeCompleto
            }}
          </a>
        </template>
      </Column>
      <Column field="numero" header="Numero Fattura" sortable>
        <template #body="slotProps">
          <a
            href="#"
            @click.prevent="openFatturaDetails(slotProps.data)"
            class="cliente-link"
          >
            {{
              slotProps.data.numero
            }}
          </a>
        </template>
      </Column>
      <Column field="importo" header="Importo" sortable></Column>
      <Column field="saldo" header="Saldo Fattura" sortable></Column>
      <Column field="cod_pratica" header="Codice Pratica" sortable></Column>
      <Column field="type_pratica" header="Tipo Pratica" sortable></Column>
      <Column field="creation_time" header="Data Creazione" sortable></Column>
      <Column field="stato" header="Stato Associazione" sortable>
      
        <template #body="slotProps">
          <span
            :class="[
              'stato-badge',
              slotProps.data.stato === 1 ? 'associato' : 'non-associato',
            ]"
          >
            {{ slotProps.data.stato === 1 ? "Associato" : "Non associato" }}
          </span>
        </template>
      </Column>
    </DataTable>
  </div>

  <Dialog
    v-model:visible="dialogVisible"
    modal
    header="Dettagli Pratica"
    :style="{ width: '50vw' }"
  >
    <div class="pratica-details">
      <div class="detail-row">
        <span class="label">ID Cliente:</span>
        <span>{{ selectedPratica?.cod_cliente }}</span>
      </div>
      <div class="detail-row">
        <span class="label">Codice Pratica:</span>
        <span>{{ selectedPratica?.cod_pratica }}</span>
      </div>
      <div class="detail-row">
        <span class="label">Importo:</span>
        <span>{{ selectedPratica?.importo }}</span>
      </div>
      <div class="detail-row">
        <span class="label">Tipo Pratica:</span>
        <span>{{ selectedPratica?.type_pratica }}</span>
      </div>
      <div class="detail-row">
        <span class="label">Stato:</span>
        <span
          :class="[
            'stato-badge',
            selectedPratica?.stato === 1 ? 'associato' : 'non-associato',
          ]"
        >
          {{ selectedPratica?.stato === 1 ? "Associato" : "Non associato" }}
        </span>
      </div>

      <div class="input-section">
        <span class="p-float-label">
          <InputText id="numeroFattura" v-model="numeroFattura" />
          <label for="numeroFattura">Numero Fattura</label>
        </span>
      </div>
    </div>

    <template #footer>
      <Button
        label="Annulla"
        icon="pi pi-times"
        @click="closeDialog"
        class="p-button-text"
      />
      <Button
        label="Associa"
        icon="pi pi-check"
        @click="associaFattura"
        autofocus
      />
    </template>
  </Dialog>
</template>

<script>
import { ref, onMounted, computed } from "vue";
//import { useStore } from 'vuex';
import Loader from "@/components/Loader.vue";
import Service from "@/services/ask-pratiche/gestione-pratiche";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Dialog from "primevue/dialog";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import Toast from "primevue/toast";
import { useToast } from "primevue/usetoast";

export default {
  components: {
    DataTable,
    Column,
    Loader,
    Dialog,
    Button,
    InputText,
    Toast,
  },
  setup() {
    const toast = useToast();
    const service = new Service();
    const preventivi = ref([]);
    const loader = ref(false);
    const selectedTipoPratica = ref(null);
    const tipoPraticaOptions = computed(() => {
      const uniqueTypes = [
        ...new Set(preventivi.value.map((item) => item.type_pratica)),
      ];
      return [
        { label: "Tutti", value: null },
        ...uniqueTypes.map((type) => ({
          label: type,
          value: type,
        })),
      ];
    });

    const filteredPreventivi = computed(() => {
      if (!selectedTipoPratica.value) {
        return preventivi.value;
      }
      return preventivi.value.filter(
        (item) => item.type_pratica === selectedTipoPratica.value
      );
    });

    const loadPreventivi = async () => {
      try {
        loader.value = true;
        const data = await service.getAllPreventiviPratica();
        preventivi.value = data;
      } catch (error) {
        console.error("Errore nel caricamento dei preventivi:", error);
      } finally {
        loader.value = false;
      }
    };

    const dialogVisible = ref(false);
    const selectedPratica = ref(null);
    const numeroFattura = ref("");

    const onRowClick = (event) => {
      selectedPratica.value = event.data;
      numeroFattura.value = event.data.numero || "";
      dialogVisible.value = true;
    };

    const closeDialog = () => {
      dialogVisible.value = false;
      selectedPratica.value = null;
      numeroFattura.value = "";
    };

    const associaFattura = async () => {
      try {
        loader.value = true;
        await service.associaFattura({
          cod_pratica: selectedPratica.value.cod_pratica,
          numero_fattura: numeroFattura.value,
        });
        await loadPreventivi();
        toast.add({
          severity: "success",
          summary: "Operazione completata",
          detail: "Fattura associata con successo",
          life: 3000,
        });
        closeDialog();
      } catch (error) {
        console.error("Errore nell'associazione della fattura:", error);
        toast.add({
          severity: "error",
          summary: "Errore",
          detail:
            "Si è verificato un errore durante l'associazione della fattura",
          life: 3000,
        });
      } finally {
        loader.value = false;
      }
    };

    const rowClass = (data) => {
      return {
        'clickable-row': true,
        'saldo-zero-row': data.saldo === 0 || data.saldo === '0'
      };
    };

    const openClienteDetails = (data) => {
      window.open(`/ask/clienti/${data.id}/dettagli`, "_blank");
    };

    const openFatturaDetails = (data) => {
      window.open(`/ask/clienti/fatture/${data.numero}/dettagli`, "_blank");
    };

    onMounted(async () => {
      await loadPreventivi();
    });

    return {
      preventivi,
      loader,
      selectedTipoPratica,
      tipoPraticaOptions,
      filteredPreventivi,
      dialogVisible,
      selectedPratica,
      numeroFattura,
      onRowClick,
      closeDialog,
      associaFattura,
      rowClass,
      openClienteDetails,
      openFatturaDetails
    };
  },
};
</script>

<style>
:deep(.p-toast) {
  z-index: 1000;
}

:deep(.p-toast-bottom-right:nth-child(2)) {
  display: none;
}

.filter-container {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
}

.btn-filter {
  font-size: 1rem !important;
  border-radius: 20px !important;
  width: 170px;
  height: 45px;
  opacity: 0.5;
  transition: opacity 0.2s ease-in-out;
  display: flex !important;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 0.5rem;
}

.btn-filter:hover {
  opacity: 1;
}

.btn-filter.selected {
  opacity: 1;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}

.table-container {
  padding: 1rem;
}

.card {
  background: #ffffff;
  border-radius: 4px;
  padding: 1rem;
}

.pratica-details {
  padding: 1rem;
}

.detail-row {
  margin-bottom: 1rem;
  display: flex;
  gap: 1rem;
}

.label {
  font-weight: bold;
  min-width: 120px;
}

.input-section {
  margin-top: 2rem;
}

.clickable-row {
  cursor: pointer;
}

.clickable-row:hover {
  background-color: #f8f9fa;
}

.stato-badge {
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-weight: 600;
}

.associato {
  color: #1da750;
}

.non-associato {
  color: #ef4444;
}

.cliente-link {
  color: #2563eb;
  text-decoration: none;
  cursor: pointer;
}

.cliente-link:hover {
  text-decoration: underline;
}

.saldo-zero-row {
  background-color: #caf5da !important; /* verde chiaro */
}

:deep(.p-datatable .p-datatable-tbody > tr.saldo-zero-row) {
  background-color: #caf5da !important;
}

:deep(.p-datatable .p-datatable-tbody > tr.saldo-zero-row:hover) {
  background-color: #4ade80 !important;
}
</style>

